import React  from 'react';
import { useSelector } from 'react-redux';
import { Query } from 'react-apollo';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Spin from 'components/common/Spin';
import { GET_STUDENT_PROFILE } from 'graphql/student/Profile';
import { GET_CONFERENCES, GET_CIRCLE_CONFERENCES } from 'graphql/conference';
import Helmet from 'react-helmet';
import BioCard from './components/BioCard';
import SessionsHistory from './components/SessionsHistory';

const useStyles = makeStyles((theme) => ({
  coaches: {
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'nowrap',
      overflow: 'auto',
      '& .MuiGrid-item': {
        maxWidth: 320,
        flexShrink: 0,
      }
    }
  }
}));

const Team = ({ history }) => {
  const user = useSelector((s) => s.user.user);
  const classes = useStyles();

  return (
    <Query query={GET_STUDENT_PROFILE} variables={{ id: user.id }}>
      {({ data, loading }) => {
        const profile = data?.student_profile[0];

        if (!profile) return <Spin spinning />;

        const CONF_QUERY = profile.group
          ? GET_CIRCLE_CONFERENCES
          : GET_CONFERENCES;
        const queryParams = profile.group
          ? { id: profile.group.group_id, userSub: user.sub }
          : { sub: user.sub };

        const coaches = [
          profile.lc_user,
          profile.hc_user,
          profile.fc_user,
        ].filter((i) => i);

        const handleSchedule = (coach) => {
          coach.user_type === 'fa_coach'
            ? history.push('/financial-aid')
            : history.push('/timeline');
        };

        return (
          <Spin spinning={loading}>
            <Helmet title="My Team" />
            <Box marginBottom={4}>
              <Grid container spacing={4} className={classes.coaches}>
                {coaches.map((coach, idx) => (
                  <Grid item xs={12} sm={4} key={idx}>
                    <BioCard profile={coach} handleSchedule={handleSchedule} />
                  </Grid>
                ))}
              </Grid>
            </Box>
            <Query query={CONF_QUERY} variables={queryParams}>
              {({ data, loading }) => {
                if (!data || loading) return <Spin spinning />;
                const conferences = data.conferences;

                const items = conferences.filter(
                  (i) => i.conference_participants.length,
                );

                return <SessionsHistory conferences={items} />;
              }}
            </Query>
          </Spin>
        );
      }}
    </Query>
  );
};

export default Team;
